import styled from 'styled-components'

interface IBudgetCategoryCardEmptyStateStyledProps {}

export const BudgetCategoryCardEmptyStateStyled = styled.div<IBudgetCategoryCardEmptyStateStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
